export default __webpack_public_path__ + "static/fabio-8b5f6ba32e821742ef577d840b56e90f.png";